import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/OY-Belleza/OY-Belleza/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["BusinessProfileView"] */ "/home/runner/work/OY-Belleza/OY-Belleza/src/components/business-profile/BusinessProfileView.tsx");
